import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/get/get.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/events/trigger/trigger.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/traversal/next-prev/next-prev.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/manipulation/insertto/insertto.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/manipulation/html/html.js";
import "dabbyjs/src/manipulation/remove/remove.js";
import "dabbyjs/src/traversal/children/children.js";
import "dabbyjs/src/dimensions/scroll/scroll.js";
import "dabbyjs/src/utils/each/each.js";
import storage from "../../javascript/storage.js";

class chatbot {

	constructor(obj, config, apps) {
		if (obj.length) {
			const development = config.development || false;

			// merge config
			this.config = {
				avatar: null, // the absolute address of the avatar graphic, if there is one
				message: null, // the ID of the message to initially load
				charspersec: development ? 2000 : 20, // how fast users read messages
				maxchars: 150, // the maximum number of characters in the message the bot is typing to use the maximum delay
				responsedelay: development ? 0 : 1000, // when the user selects a response, this sets how long to wait before invoking the next action
				progressdelay: 3000, // when navigating the user to a URL, this is how long the bot waits before initiating the action
				nudgedelay: 10000, // how long before the nudge message appears
				nudgekey: "chatbot", // the local storage key to remember the last time the bot popped
				nudgepages: 3,
				popupintersect: ["article", "main"],
				sounds: [], // stores the URLs to various audio files
				development: development, // prevents logging
				...config
			};

			// setup bot
			this.cls = obj.attr("class").split(" ")[0];
			this.nudgemsgs = $("." + this.cls + "__nudge-switch");
			this.switch = $("." + this.cls + "__switch");
			this.window = $("." + this.cls + "__window", obj);
			this.chat = $("." + this.cls + "__chat", obj);
			this.typing = $("." + this.cls + "__typing", obj);
			this.typingcls = this.cls + "__typing--active";
			this.timer = false;
			this.promise = Promise.resolve(); // the main promise chain
			this.content = null; // stores the messages which will be fetched from the server when the bot is summoned
			this.variables = {};
			this.path = []; // remembers all the previous messages - for going back
			this.muted = false; // whether sounds are currently playing

			// merge functions
			this.apps = Object.assign({
				reset: (item, persistent = false) => this.clearVars(persistent).empty().start(),
				close: () => {
					return this.clearVars().empty().then(() => {
						this.switch.prop("checked", false);
					});
				},
				help: () => this.code("help"),
				navigate: data => {
					return this.sequence(resolve => {
						const cls = this.cls + "__chat-item",
							item = $("." + cls, this.chat).eq(-1).addClass(cls + "--loading");
						setTimeout(() => {
							const url = data.url + (data.next ? (data.url.includes("?") ? "&" : "?") + "action=chatbot&msg=" + data.next : "");

							// open in a new window
							if (data.newwindow) {
								item.removeClass(cls + "--loading");
								open(url, "_blank");

								// go to the next message
								if (data.next) {
									this.message(data.next);

								// go back to the previous message
								} else {
									this.apps.back(false);
								}
							
							// redirect this window
							} else {
								location.href = url;
							}
							resolve();
						}, data.messages ? this.config.progressdelay : 0);
					});
				},
				next: item => this.then(() => {
					this.message(item.next);
				}),
				back: (showmsg = true) => {
					return this.load().then(msgs => {

						// remove last message ID
						this.path.pop();

						// get the last ID
						const id = this.path[this.path.length - 1];

						// if the last message forwards to this one, go back again
						if (this.path.length > 1 && msgs[id].next) {
							this.apps.back();

						// response and trigger the next message
						} else {
							this.path.pop(); // remove itself, we will add it back
							if (showmsg) {
								this.response("Go back");
							}
							this.message(id, false);
						}
					});
				},
				submit: item => {

					// add progress bar to last message
					if (item.url) {
						this.sequence((resolve, reject) => {
							const cls = this.cls + "__chat-item",
								join = item.url.includes("?") ? "&" : "?";
							$("." + cls, this.chat).eq(-1).addClass(cls + "--loading");
							let time = new Date().getTime();

							// request hidden page vars
							fetch(item.url + join + "action=chatbot&type=form", {
								headers: {accept: "application/json"}
							}).then(response => {
								return response.json();
							}).then(json => {
								return json.vars;
							}).then(vars => {
								resolve();

								// send the form
								this.sequence((resolve, reject) => {
									const data = new FormData();

									// encode hidden vars
									$.each(vars, (key, item) => {
										data.append(key, item);
									});

									// encode variables
									$.each(this.variables, (key, item) => {
										data.append(key, item);
									});

									// post the form
									fetch(item.url, {
										method: "POST",
										body: data,
										headers: {accept: "application/json"}
									})
									.then(response => response.json())
									.then(json => {

										// tell the user the response
										this.sequence(resolve => {
											resolve();

											// remove progress bars
											const cls = this.cls + "__chat-item--loading";
											$("." + cls, this.chat).removeClass(cls);

											// say the response
											this.say($("<p>", {text: json.msg}), this.cls + "__chat-item--" + (json.error ? "error" : "success")).load().then(msgs => {

												// go to another message?
												let msg = item.next,
													error = false;

												// wipe variables if not in error
												if (!json.error) {
													this.clearVars().sequence(resolve => {
														setTimeout(() => {
															this.message(item.next);
															resolve();
														}, this.config.responsedelay);
													});

												// error and a specific control is in error
												} else if (json.control) {
													let path = this.path,
														i = path.length;
													error = true;
													while (i--) {
														if (msgs[path[i]].key === json.control) {
															msg = path[i];
															this.path = path.slice(0, i);
															this.message(msg, false);
															error = false;
															break;
														}
													}
												} else {
													setTimeout(() => {
														this.path.pop();
														this.message(this.path.pop(), false); // remove last item
													}, this.config.responsedelay);
												}

												// go to the error message
												if (error) {
													this.code("error");
												}
											});
										});
										resolve();
									}).catch(e => {
										this.say($("<p>", {text: "Sorry, an unknown error occurred"})).code("error");
										reject();
									});
								});
							})
							.catch(e => {
								this.say($("<p>", {text: "Sorry, there was a problem submitting the form"})).code("error");
								reject();
							});
						});
					} else {
						this.say($("<p>", {text: "Sorry, there was a problem submitting the form"})).code("error");
					}
				}
			}, apps || {});

			// functions
			const mutecls = this.cls + "__mute",

				// mute all sounds
				mute = $("." + mutecls).on("click", e => {
					this.muted = !this.muted;
					$(e.target)[(this.muted ? "add" : "remove") + "Class"](mutecls + "--disabled");
				}),

				// reset the bot
				reset = $("." + this.cls + "__reset").on("click", () => {
					this.apps.reset(null, true);
				}),

				// show the interactive help
				help = $("." + this.cls + "__help").on("click", () => {
					this.apps.help();
				});
			this.controls = reset.add(help);

			// always scroll to the bottom of the window when the height changes
			let height = 0;
			const scroll = new ResizeObserver(entries => {
				entries.forEach(entry => {
					if (entry.contentBoxSize[0].blockSize > height) {
						this.window.scrollTop(height);
					}
					height = entry.contentBoxSize[0].blockSize;
				});
			});
			scroll.observe(this.chat.get(0));

			// summon the bot
			this.switch.on("change", () => {
				const checked = this.switch.prop("checked");
				this.nudgemsgs.prop("checked", false);
				this.chat.attr("aria-live", checked ? "polite" : "off");
				if (checked) {
					this.start(this.config.message);
				}
			});

			// add fullscreen class to body to hide scrollbar
			$("." + this.cls + "__fullscreen").on("change", e => $("body").toggleClass(this.cls + "--fullscreen", e.target.checked));

			// if the bot is already on the screen then start it
			if (this.switch.prop("checked")) {
				this.start(this.config.message);

			// popup when an intersection is reached
			} else if (this.config.message) {
				this.popup(this.config.message);

			// nudge
			} else {
				const usestorage = storage(),
					value = usestorage ? localStorage.getItem(this.config.nudgekey) : 0;

				// check the last time they saw the popup
				if (value <= 0) {
					setTimeout(() => {
						this.nudge();
						if (usestorage) {
							localStorage.setItem(this.config.nudgekey, this.config.nudgepages); // record how many pages before we pop again
						}
					}, this.config.nudgedelay);

				// minus 1 off the viewed pages
				} else if (usestorage) {
					localStorage.setItem(this.config.nudgekey, value-1);
				}
			}
		}
	}

	start(id) {
		return this.load().then(content => {
			if (!this.chat.get(0).hasChildNodes()) {

				// if requested message is not set or doesn't exist, use configured start message
				if (content[id]) {
					this.message(id);

				// use first message
				} else {
					this.code("start");
				}
			}
		});
	}

	load() {
		if (this.content === null) {
			this.sequence(resolve => {
				fetch(this.config.href, {headers: {accept: "application/json"}})
					.then(response => response.json())
					.then(json => {
						this.content = json.content;
						resolve(json.content);
					});
			});
		} else {
			this.then(() => this.content);
		}
		return this;
	}

	nudge() {
		let prom = Promise.resolve();
		this.nudgemsgs.each((i, item) => {
			prom = prom.then(() => {
				return new Promise(resolve => {

					// check if the bot is open
					if (this.switch.prop("checked")) {
						reject();

					// invoke the next message
					} else {
						const $this = $(item);
						$this.prop("checked", true);
						setTimeout(() => this.play(i ? "newmessage" : "nudge", true), 400);
						setTimeout(() => {
							resolve($this);
						}, $this.data("delay") || this.getDelay($this.next().text()) + this.config.responsedelay);
					}
				});
			}).then(item => {
				return new Promise((resolve, reject) => {
					setTimeout(() => {
						item.prop("checked", false);
						setTimeout(() => {
							resolve();
						}, this.config.responsedelay);
					}, this.config.responsedelay);
				});
			}).catch(e => {});
		});
	}

	popup(id) {

		// find the object we are observing
		let obj, intersect;
		for (let i = 0, len = this.config.popupintersect.length; i < len; i++) {
			obj = $(this.config.popupintersect[i]);
			if (obj.length) {
				intersect = $("<div>", {"class": this.cls + "__intersect"}).insertAfter(obj).get(0);
				break;
			}
		}

		// setup the observer
		if (obj !== null) {
			const observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {

					// are we scrolling down?
					if (entry.isIntersecting) {
						this.start(id);
					}
				});
			}, {threshold: 1});
			observer.observe(intersect);

			// remove the event handler when it is opened
			this.switch.one("change", () => observer.unobserve(intersect));
		}
	}

	getId(name) {
		return this.load().then(msgs => {
			let id = null;
			$.each(msgs, (i, item) => {
				if (item.name === name) {
					id = item.id;
					return false;
				}
			});
			return id;
		});
	}

	code(name) {
		return this.getId(name).then(id => {
			if (id) {
				const item = this.content[id];
				if (item.response) {
					this.response(item.response);
				}
				this.message(id);
			}
		});
	}

	getDelay(text, first = false, delay = null) {
		if (this.config.development) {
			return 0;
		} else if (delay) {
			return delay;
		} else {
			const cps = this.config.charspersec * (first ? 3 : 1),
				chars = this.config.maxchars,
				len = text.length > chars ? chars : text.length;
			return (1000 / cps) * len;
		}
	}

	message(id, allowskipping = true) {

		this.removeControls().load().then(msgs => {

			// check the message exists
			if (msgs[id]) {
				const msg = msgs[id];
				let skip = false;

				// skip if has a form control with a variable that is set
				if (allowskipping && msg.type && msg.key && msg.next && this.variables[msg.key] !== undefined && this.variables[msg.key] !== msg.value) {
					this.message(msg.next);
					skip = true;
				}

				// if there is a variable set on any of the actions, skip the question and go to its child
				if (!skip && allowskipping && msg.actions) {
					skip = msg.actions.some(item => {
						const msg = msgs[item.id];
						if (msg.key && this.variables[msg.key] === msg.value) {
							this.message(item.id);
							return true;
						}
						return false;
					});
				}

				// if not skipping then continue
				if (!skip) {
					this.path.push(id);

					// load the message
					const config = this.config;

					// make sure the bot is open
					this.switch.prop("checked", true);

					// add bot messages
					if (msg.messages) {
						const last = parseInt(Object.keys(msg.messages).slice(-1)[0]);
						msg.messages.forEach((item, i) => {
							this.sequence(resolve => {

								// calculate message delay
								const delay = this.getDelay(item.text, !i, item.delay),
									typing = i && delay ? delay / 3 : 0;

								// show typing message
								if (delay) {
									setTimeout(() => {
										this.typing.addClass(this.typingcls);
									}, typing > this.config.responsedelay ? this.config.responsedelay : typing);
								}

								// add message to stream
								setTimeout(() => {
									let html = this.replaceVars(item.text),
										wrap,
										control = $();

									// add control
									if (msg.type && last === i) {
										const value = this.variables[msg.key] || msg.value;

										// render stars control
										if (msg.type === "stars") {
											wrap = $("<div>", {"class": this.cls + "__chat-control " + this.cls + "__chat-stars"});
											for (let i = 5; i >= 1; i--) {
												wrap
													.append($("<input>", {
														type: "radio", 
														name: "stars",
														"class": this.cls + "__chat-control-stars",
														id: "star-"+i,
														value: i,
														checked: value === i ? "checked" : null,
														change: () => {
															this.variables[msg.key] = i;
															this.response(i + " stars out of 5");
															this.message(msg.next);
														}
													}))
													.append($("<label>", {
														type: "radio", 
														"aria-label": i + " stars",
														name: "stars",
														"class": this.cls + "__chat-stars-label",
														for: "star-"+i,
														text: "★"
													}));
											}

										// render input or textarea
										} else {
											const input = msg.type !== "text";
											wrap = $("<form>", {
												"class": this.cls + "__chat-control",
												submit: e => {
	
													// string based controls
													if (msg.type !== "file") {
														const val = control.val();
														this.variables[msg.key] = val;
														this.response(val);
	
													// file upload
													} else {
														const file = control.get(0).files[0];
														if (file) {
															this.variables[msg.key] = file;
															this.response(file.name);
														}
													}
													this.message(msg.next);
													e.preventDefault();
												}
											});
											control = $(input ? "<input>" : "<textarea>", {
												"class": this.cls + "__chat-control-" + (input ? "input" : "text"),
												placeholder: msg.label,
												type: input ? (["number", "email", "file"].includes(msg.type) ? msg.type : "text") : null,
												required: "required"
											});
											if (msg.type !== "file") {
												control[input ? "val" : "text"](value);
											}
											wrap
												.append(control)
												.append($("<button>", {
													"class": this.cls + "__chat-control-submit"
												}));
										}
										html = html.add(wrap);
									}
									this.say(html).then(() => {
										control.trigger("focus");
									});
									resolve();
								}, delay);
							});
						});
					}

					// log the message
					if (!config.development) {
						this.then(div => {
							let referrer = document.referrer && location.href.indexOf(document.referrer) !== 0 ? new URL(document.referrer) : null;
							fetch(this.config.href + "&log=" + id + (referrer && referrer.hostname ? "&referrer=" + encodeURIComponent(referrer.hostname) : ""), {headers: {accept: "application/json"}});
							return div;
						});
					}

					// add buttons
					if (msg.actions) {
						this.then(() => {
							const actions = $("<div>", {
								"class": this.cls + "__chat-actions"
							});

							msg.actions.forEach(item => {

								// render the answer buttons
								$("<button>", {
									"class": this.cls + "__chat-actions-item",
									text: item.button,
									click: e => {
										const next = msgs[item.id];

										// if a variable, record the value
										if (next.key) {
											this.variables[next.key] = next.value;
										}

										// add response message
										this
											.response(next.response || next.button)
											.sequence(resolve => {

												// queue the response
												setTimeout(() => {
													this.message(item.id);
													resolve();
												}, this.config.responsedelay);
											});
										e.preventDefault();
									}
								}).appendTo(actions);
							});

							// add the actions nodes to the chat
							this.chat.append(actions);
						});
					}

					// run application
					if (msg.app) {
						this.apps[msg.app](msg);

					// add back button only when there are more than two messages or the first doesn't forward to the second
					} else if (this.path.length > 2 || !msgs[this.path[0]].next) {
						this.then(() => {
							if (this.chat.get(0).hasChildNodes()) {
								$("<button>", {
									"class": this.cls + "__chat-back icon-up",
									text: "Back",
									click: () => {
										this.apps.back(msg);
									}
								}).appendTo(this.chat);
							}
						});
					}
				}
			}
		});
		return this;
	}

	removeControls() {

		// remove edit functionality
		let cls = this.cls + "__chat-edit";
		$("." + cls, this.chat).off("click").removeClass(cls);

		// remove actionable controls
		const remove = $("." + this.cls + "__chat-actions, ." + this.cls + "__chat-back, ." + this.cls + "__chat-control", this.chat);
		if (remove.length) {
			remove.addClass(this.cls + "__chat-item--hide");

			this.sequence(resolve => {
				// remove previous controls
				setTimeout(() => {
					remove.remove();
					resolve();
				}, 200);
			});
		}
		return this;
	}

	say(html, cls = null) {

		// stop typing
		this.typing.removeClass(this.typingcls);

		// add the message
		const div = $("<div>", {
			"class": this.cls + "__chat-item" + (this.config.avatar ? " " + this.cls + "__chat-item--hasavatar" : "") + (cls === null ? "" : " " + cls)
		});

		// draw the avatar
		if (this.config.avatar) {
			div.append($("<img>", {
				src: this.config.avatar,
				alt: this.config.name,
				width: "30px",
				height: "30px",
				"class": this.cls + "__chat-item-avatar"
			}));
		}

		// append the HTML
		div.append(html);

		// attach to the chat window
		this.chat.append(div);
		this.play("newmessage");
		div.attr("tabindex", "-1").trigger("focus");
		return this;
	}

	response(msg) {
		return this.removeControls().then(() => {

			// add response message
			this.chat.append($("<div>", {
				"class": this.cls + "__chat-response",
				text: msg
			}));

		});
	}

	empty() {
		return this.sequence(resolve => {
			const children = this.chat.children().addClass(this.cls + "__chat-item--hide");
			setTimeout(() => {
				children.remove();
				resolve();
			}, 500);
		});
	}

	sequence(callback) {
		this.promise = this.promise
			.then(() => {
				this.controls.prop("disabled", true);
				return new Promise(callback).then(arg => {
					this.controls.prop("disabled", false);
					return arg;
				});
			})
		return this;
	}

	then(callback) {
		this.promise = this.promise.then(callback);
		return this;
	}

	replaceVars(text) {
		const obj = $("<div>"),
			vars = this.variables,
			html = $(text);
		$.each($("*", html).get().reverse(), (i, item) => { // nodes must be read in reverse order to get leaves first, so the parent isn't replaced before the child
			const $this = $(item),
				html = $this.html();

			// update a tag that only contains the value with a class and make clickable
			let match, key;
			if ((match = /^\{([a-z0-9_-]+)\}$/i.exec(html)) !== null && (key = this.path.findIndex(i => this.content[i].key === match[1])) !== -1) {
				let value = vars[match[1]].name || vars[match[1]] || "[Not Set]";
				if (value.length > 255) {
					value = value.substring(0, 255) + "…";
				}
				$this
					.text(value)
					.attr("title", "Edit this value")
					.addClass(this.cls + "__chat-edit")
					.on("click", () => {
						const item = this.content[this.path[key]],
							id = this.path[item.type === null && item.key !== null && item.value !== null ? key-1 : key]; // for click button selection, go to the previous message
						this.response("Edit " + item.label).message(id, false);
					});

			// just replace the value with the text
			} else {
				$this.html(html.replace(/\{([a-z0-9_-]+)\}/gi, (match, key) => obj.text(vars[key] || "[Not Set]").html()));
			}
		});
		return html;
	}

	play(id, playwhenclosed = false) {
		if (!this.muted && this.config.sounds[id] && (playwhenclosed || this.switch.prop("checked"))) {
			const url = this.config.sounds[id];
			if (!(this.audio instanceof Audio)) {
				this.audio = new Audio(url);
				this.audio.addEventListener("canplaythrough", () => {
					this.audio.play();
				});
			} else if (this.audio.src !== location.origin + url) {
				this.audio.src = url;
				this.audio.load();
			} else {
				this.audio.play();
			}
		}
	}

	clearVars(persistent = false) {
		this.load().then(msgs => {
			$.each(msgs, (i, item) => {
				if (item.key && (persistent || !item.persistent) && this.variables[item.key] !== undefined) {
					delete this.variables[item.key];
				}
			})
		});
		return this;
	}
}

export default (obj, apps) => {
	obj.each(function () {
		const $this = $(this),
			config = $this.data("chatbot");
		if (config) {
			const bot = new chatbot($this, config, apps);
		}
	});
};
